export interface EndpointDetailsWebComponentSchema {
  endpointId: string;
  companyId: string;
  operatingSystem: number;
  name: string;
  ip: string;
  label: string;
  ma: {
    company: boolean;
    endpoint: boolean;
  };
  features: {
    remoteAccess: boolean;
  };
  isManaged: boolean;
}

export const DATA_LOADED_EVENT = 'dataLoaded';
